module.exports = __webpack_public_path__ + "static/media/pic4.6e854080.png";